import { IntentFact } from '@interhyp/shared-interim-portal';
import React, { useMemo } from 'react';

import styles from './MortgageIntent.module.scss';

export const FinancingReasonMapping: Record<string, string> = {
  BUILD: 'Neubau',
  BUY_NEW: 'Kauf Neubau',
  BUY_EXISTING: 'Kauf Bestand',
  RAISE_CAPITAL: 'Kapitalbeschaffung',
  REFINANCE: 'Anschlussfinanzierung',
  RENOVATE: 'Modernisierung',
};

const EstateFactUsageMapping: Record<string, string> = {
  SELF: 'selbstgenutzt',
  RENT: 'vermietet',
  MIXED: 'teilvermietet',
};

export function MortgageIntent({ intent }: { intent?: IntentFact }): React.ReactElement {
  const data = useMemo(() => {
    const type = FinancingReasonMapping[intent?.estates?.[0].projectType ?? ''];
    const usage = EstateFactUsageMapping[intent?.estates?.[0].usage ?? ''];

    const address = intent?.estates?.[0].address;

    const fullStreet = [address?.street, address?.housenumber].filter(Boolean).join(' ');
    const fullCity = [address?.zip, address?.city].filter(Boolean).join(' ');

    const formattedAddress = [fullStreet, fullCity].filter(Boolean).join(', ');

    return [type, usage, formattedAddress].filter(Boolean);
  }, [intent?.estates]);

  return (
    <div>
      <strong>Baufinanzierung {intent?.intentId}</strong>
      <p className={styles.subline}>{data.join('  •  ')}</p>
    </div>
  );
}
